import { supabase } from '@/integrations/supabase/client';

/**
 * Ensures the user has an active session, throwing an error if not authenticated.
 *
 * This utility replaces the common pattern:
 * ```typescript
 * const { data: { session } } = await supabase.auth.getSession();
 * if (!session) throw new Error("Not authenticated");
 * ```
 *
 * @returns The active session object
 * @throws Error if no active session is found
 *
 * @example
 * ```typescript
 * // In a mutation or async function:
 * const session = await requireSession();
 * // Use session.access_token, etc.
 * ```
 */
export async function requireSession() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return session;
}
